export var BUCKET_NAME_MIN_LENGTH = 3;
export var BUCKET_NAME_MAX_LENGTH = 63;
// https://docs.aws.amazon.com/AmazonS3/latest/dev/BucketRestrictions.html#bucketnamingrules
var REGEX = {
    firstCharIsDigitOrLowerCaseLetter: /^[a-z0-9]{1}/,
    capitalLetter: /[A-Z]/,
    dnsName: /^(([a-z0-9]|[a-z0-9][a-z0-9-]*[a-z0-9])\.)*([a-z0-9]|[a-z0-9][a-z0-9-]*[a-z0-9])$/
};
export var uriStartsWithS3Protocol = function (_a) {
    var uri = _a.uri;
    return uri.slice(0, 5) === 's3://';
};
export var bucketNameStartsWithDigitOrLowerCaseLetter = function (_a) {
    var bucketName = _a.bucketName;
    return REGEX.firstCharIsDigitOrLowerCaseLetter.test(bucketName);
};
export var noCapitalLettersInBucketName = function (_a) {
    var bucketName = _a.bucketName;
    return !REGEX.capitalLetter.test(bucketName);
};
export var bucketNameLength = function (_a) {
    var bucketName = _a.bucketName;
    return BUCKET_NAME_MIN_LENGTH <= bucketName.length && bucketName.length <= BUCKET_NAME_MAX_LENGTH;
};
export var dnsNameCompliance = function (_a) {
    var bucketName = _a.bucketName;
    return REGEX.dnsName.test(bucketName);
};
export var validationErrorStrings = function (i18nStrings) {
    return {
        uriStartsWithS3Protocol: i18nStrings.validationPathMustBegin,
        bucketNameStartsWithDigitOrLowerCaseLetter: i18nStrings.validationBucketLowerCase,
        noCapitalLettersInBucketName: i18nStrings.validationBucketMustNotContain,
        bucketNameLength: i18nStrings.validationBucketLength,
        dnsNameCompliance: i18nStrings.validationBucketMustComplyDns
    };
};
//# sourceMappingURL=validation-rules.js.map